import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  fetchCountriesListCount: ['filter'],
  fetchCountriesListCountLoading: null,
  fetchCountriesListCountSuccess: ['countriesCount'],
  fetchCountriesListCountFail: ['error'],

  fetchCountriesList: ['filter', 'offset', 'shouldShowError'],
  fetchCountriesListLoading: null,
  fetchCountriesListSuccess: ['offset', 'countries', 'nextOffset'],
  fetchCountriesListFail: ['error'],

  setCountriesFilter: ['newFilter'],
  clearCountriesFilter: null,
  clearCountries: null,

  addCountry: ['country'],
  addCountryLoading: null,
  addCountrySuccess: ['country'],
  addCountryFail: ['error'],
})

export const CountriesTypes = Types
export default Creators
